import { useContext } from 'react'
import { ActionContext } from '@/context/ActionContext'

export const useAction = () => useContext(ActionContext)
